const URL_CONFIG = {
  NOT_FOUND: "/404",
};

export default URL_CONFIG;
